import { sanitizeCnpj } from './string'

export type FiscalNoteBorrowerFilter = {
  borrower_name?: string
  borrower_tax_id?: string
}

const MIN_BORROWER_SEARCH_LENGTH = 3

export function resolveFiscalNoteBorrowerFilter(
  input: string,
): FiscalNoteBorrowerFilter {
  const trimmed = input.trim()
  if (trimmed.length < MIN_BORROWER_SEARCH_LENGTH) return {}

  const taxId = sanitizeCnpj(trimmed)
  const hasAccent = /[À-ÿ]/.test(trimmed)
  const hasWhitespace = /\s/.test(trimmed)
  const hasDigit = /\d/.test(taxId)

  if (taxId && hasDigit && !hasAccent && !hasWhitespace) {
    return { borrower_tax_id: taxId }
  }

  return { borrower_name: trimmed }
}
